"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PoweredBy = PoweredBy;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactInstantsearchHooks = require("react-instantsearch-hooks");

var _PoweredBy = require("../ui/PoweredBy");

function PoweredBy(props) {
  var _usePoweredBy = (0, _reactInstantsearchHooks.usePoweredBy)(),
      url = _usePoweredBy.url;

  var uiProps = {
    url: url
  };
  return /*#__PURE__*/_react.default.createElement(_PoweredBy.PoweredBy, (0, _extends2.default)({}, props, uiProps));
}